import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/pipelines")({
  beforeLoad: () => {
    throw redirect({ to: "/monitoring" });
  },
  component: () => null,
});
